<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb"></sm-page-header>
    <div class="content">
        <div class="flex items-center gap-6">
            <sm-form-builder [formObject]="formObject"></sm-form-builder>
            <p-button [label]="'settings.contractingAuthority.history.search' | translate" (click)="confirm()" [disabled]="isSearchDisabled$ | async"></p-button>
        </div>
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
        <sm-spinner [loading]="loading"></sm-spinner>
    </div>
</div>